import { render, staticRenderFns } from "./notice-input.vue?vue&type=template&id=345ecbea&scoped=true&"
import script from "./notice-input.vue?vue&type=script&lang=js&"
export * from "./notice-input.vue?vue&type=script&lang=js&"
import style0 from "./notice-input.vue?vue&type=style&index=0&id=345ecbea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345ecbea",
  null
  
)

export default component.exports